import { state } from '@/manager/product/store/state';
import { getters } from '@/manager/product/store/getters';
import { mutations } from '@/manager/product/store/mutations';
import { actions } from '@/manager/product/store/action';

export const product = {
    state,
    getters,
    actions,
    mutations,
};
